@if (!labels || labels.length===0) {
    <p>There is no data available to show</p>
}@else {
    <div style="width:95%;padding:10px;">
        <canvas baseChart
            [type]="'line'"
            [height]="height"
            [datasets]="values"
            [labels]="labels"
            (chartClick)="onSelect($event)"
            [options]="chartOptions"
            [plugins]="chartPlugins"
            [legend]="chartLegend">
        </canvas>
    </div>
}

